"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreQualAction = void 0;
var PreQualAction;
(function (PreQualAction) {
    // complete, we will send this action to the front end to route applicant to the right page
    PreQualAction["experianFail"] = "experianFail";
    PreQualAction["experianFrozen"] = "experianFrozen";
    PreQualAction["coApplicantExperianFrozen"] = "coApplicantExperianFrozen";
    PreQualAction["experianNoFile"] = "experianNoFile";
    PreQualAction["coApplicantExperianNoFile"] = "coApplicantExperianNoFile";
    PreQualAction["experianNotFound"] = "experianNotFound";
    PreQualAction["coApplicantExperianNotFound"] = "coApplicantExperianNotFound";
    PreQualAction["experianFailedWithIneligibleError"] = "experianFailedWithIneligibleError";
    PreQualAction["experianFailFixable"] = "experianFailFixable";
    PreQualAction["transUnionFrozen"] = "transUnionFrozen";
    PreQualAction["transUnionNoFile"] = "transUnionNoFile";
    PreQualAction["missingTransUnionReport"] = "missingTransUnionReport";
    PreQualAction["isIneligible"] = "isIneligible";
    PreQualAction["skipPrequal"] = "skipPrequal";
    PreQualAction["showPrequal"] = "showPrequal";
    /**
     * @deprecated Account agreement is now auto-signed in the status transition listener when the application
     * reaches preQualificationAccepted status. Use PreQualAction.showPrequal instead.
     * This will be removed once all frontend references are cleaned up.
     */
    PreQualAction["showPrequalAndAutoESignAccountAgreement"] = "showPrequalAndAutoESignAccountAgreement";
    PreQualAction["autoAcceptAndSkipPrequal"] = "autoAcceptAndSkipPrequal";
    PreQualAction["offerAddCoApplicant"] = "offerAddCoApplicant";
    PreQualAction["blockRepeatApplicant"] = "blockRepeatApplicant";
    PreQualAction["remedyOwnerNameMismatch"] = "remedyOwnerNameMismatch";
    PreQualAction["remedyOwnerNameMismatchTokenMatch"] = "remedyOwnerNameMismatchTokenMatch";
    PreQualAction["blockedApplication"] = "blockedApplication";
    PreQualAction["underwritingFail"] = "underwritingFail";
    PreQualAction["unsupportedCounty"] = "unsupportedCounty";
    PreQualAction["unsupportedFirstLienInState"] = "unsupportedLienPositionInState";
    PreQualAction["unsupportedRefiTitleInsuranceInState"] = "unsupportedRefiTitleInsuranceInState";
    PreQualAction["homeOwnership"] = "homeOwnership";
    PreQualAction["homeIsLLC"] = "homeIsLLC";
    PreQualAction["homeIsTrustAndRin"] = "homeIsTrustAndRin";
    PreQualAction["homeIsTrustAndNOO"] = "homeIsTrustAndNOO";
    PreQualAction["homeIsTrustInNotSupportedState"] = "homeIsTrustInNotSupportedState";
    // NOO property in a state that requires offline (in-person) closing AND the applicant's
    // personal residence is in a different state — we can't host the in-person closing at the
    // property (NOO) and we won't ask the borrower to travel out of state. Same-state NOO is fine.
    PreQualAction["nooInOfflineNotaryStateMismatchedAddress"] = "nooInOfflineNotaryStateMismatchedAddress";
    PreQualAction["denied"] = "denied";
    PreQualAction["humanInvestigate"] = "humanInvestigate";
    PreQualAction["expired"] = "expired";
    PreQualAction["disputableProviderData"] = "disputableProviderData";
    PreQualAction["withdrawn"] = "withdrawn";
    PreQualAction["lienInformationVerification"] = "lienInformationVerification";
    PreQualAction["missingLienAttestation"] = "missingLienAttestation";
    PreQualAction["missingUserProvidedAllLienInfo"] = "missingUserProvidedAllLienInfo";
    PreQualAction["missingAssetVerification"] = "missingAssetVerification";
    PreQualAction["missingTexas50a6Attestation"] = "missingTexas50a6Attestation";
    PreQualAction["propertySizeTooLargeInState"] = "propertySizeTooLargeInState";
    // TODO: Add a prequal action corresponding to every loan application terminal status (terminalLoanApplicationStatuses)
})(PreQualAction || (exports.PreQualAction = PreQualAction = {}));
